var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetProfitFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 19.5,
    stroke: "#19C48F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 20.5C22.0815 20.5 22.3995 20.6317 22.6339 20.8661C22.8683 21.1005 23 21.4185 23 21.75V43H44.25C44.5562 43 44.8517 43.1124 45.0805 43.3159C45.3093 43.5193 45.4554 43.7997 45.4912 44.1037L45.5 44.25C45.5 44.5815 45.3683 44.8995 45.1339 45.1339C44.8995 45.3683 44.5815 45.5 44.25 45.5H21.75C21.4185 45.5 21.1005 45.3683 20.8661 45.1339C20.6317 44.8995 20.5 44.5815 20.5 44.25V21.75C20.5 21.4185 20.6317 21.1005 20.8661 20.8661C21.1005 20.6317 21.4185 20.5 21.75 20.5Z",
    fill: "#19C48F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75 23C42.2763 23.0012 42.7964 23.1131 43.2766 23.3285C43.7567 23.544 44.1862 23.858 44.537 24.2503C44.8878 24.6426 45.1521 25.1044 45.3127 25.6056C45.4733 26.1067 45.5266 26.6361 45.4692 27.1592C45.4117 27.6823 45.2448 28.1875 44.9793 28.6419C44.7138 29.0963 44.3556 29.4897 43.9281 29.7966C43.5005 30.1034 43.0132 30.3168 42.4977 30.423C41.9823 30.5291 41.4502 30.5255 40.9363 30.4125L38.4338 34.415C38.8596 34.95 39.1311 35.5913 39.2188 36.2695C39.3064 36.9477 39.207 37.637 38.9312 38.2627C38.6554 38.8885 38.2138 39.4269 37.6541 39.8198C37.0943 40.2126 36.4378 40.4449 35.7556 40.4916C35.0734 40.5383 34.3914 40.3975 33.7834 40.0845C33.1753 39.7715 32.6645 39.2982 32.3061 38.7159C31.9477 38.1335 31.7553 37.4642 31.7498 36.7804C31.7443 36.0966 31.926 35.4243 32.275 34.8363L30.5525 32.7675C29.7231 33.0746 28.8117 33.0787 27.9796 32.779C27.1474 32.4793 26.448 31.8951 26.0049 31.1296C25.5618 30.3641 25.4035 29.4666 25.558 28.5958C25.7125 27.7249 26.1699 26.9366 26.8493 26.3703C27.5287 25.804 28.3864 25.4961 29.2709 25.5009C30.1553 25.5057 31.0096 25.8231 31.6828 26.3968C32.3559 26.9705 32.8047 27.7637 32.9496 28.6362C33.0946 29.5087 32.9265 30.4044 32.475 31.165L34.1975 33.2325C34.8743 32.9815 35.6092 32.9316 36.3138 33.0887L38.8163 29.085C38.377 28.533 38.1023 27.8682 38.0238 27.1671C37.9454 26.4659 38.0663 25.7569 38.3727 25.1214C38.6791 24.4859 39.1585 23.9497 39.7559 23.5745C40.3533 23.1992 41.0445 23.0001 41.75 23Z",
    fill: "#19C48F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetProfitFeature);
export default __webpack_public_path__ + "static/media/net_profit_feature.3125710bd263341db68f508e863cb755.svg";
export { ForwardRef as ReactComponent };